import { newsletterUnsubscribe } from '@/api/apiConstants'
import { post, postWithAuth } from '@/api/httpRequests'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppStore } from '@/shared/store'
import { useSharedStyles } from '@/pages/Settings/useSharedStyles'
import { useTranslation } from 'react-i18next'

import {
    buttonStyle,
    buyButtonStyle,
} from '@/features/VOD/components/itemDetails/styles/detailsButtonsStyles'

const NewsletterContent = () => {
    const { t: translate } = useTranslation()
    const location = useLocation()

    // Pobierz parametry z URL
    const searchParams = new URLSearchParams(location.search)
    const emailId = searchParams.get('email_id')
    const token = searchParams.get('token')

    const [isProcessing, setIsProcessing] = useState(false)
    const [message, setMessage] = useState<string | null>(null)
    const [success, setSuccess] = useState<boolean | null>(null)

    const { container, sectionStyle } = useSharedStyles()

    const handleUnsubscribe = async () => {
        setIsProcessing(true)
        setMessage(null)
        setSuccess(null)

        try {
            const body = JSON.stringify({ emailId, token })
            const response = await post(newsletterUnsubscribe, true, body)

            if (response.result === 'ok') {
                setMessage(translate('newsletterCancelSuccess'))
                setSuccess(true)
            } else {
                setMessage(translate('newsletterCancelError'))
                setSuccess(false)
            }
        } catch (error) {
            setMessage(translate('newsletterCancelConnectionError'))
            setSuccess(false)
        } finally {
            setIsProcessing(false)
        }
    }

    return (
        <Box sx={container}>
            <Box sx={sectionStyle}>
                <Typography variant="h4" gutterBottom>
                    {translate('newsletterCancelTitle')}
                </Typography>

                {success !== true && (
                    <>
                        <Typography variant="body1" gutterBottom>
                            {translate('newsletterCancelSubtitle')}
                        </Typography>
                        <Button
                            onClick={handleUnsubscribe}
                            disabled={isProcessing}
                            sx={{
                                ...buttonStyle,
                                ...buyButtonStyle,
                                marginTop: '1rem',
                            }}>
                            {translate('newsletterCancelButton')}
                        </Button>
                    </>
                )}
                {isProcessing ? <CircularProgress size={24} /> : null}

                {message && (
                    <Typography
                        variant="body2"
                        sx={{
                            color: success ? 'green' : 'red',
                            marginTop: '1rem',
                        }}>
                        {message}
                    </Typography>
                )}
            </Box>
        </Box>
    )
}

export { NewsletterContent }
